/**
 * is where we store app options.
 */

e.options = {
	desktop_breakpoint: 960,
	mobile_breakpoint : 400,
	tablet_breakpoint : 768
};
